import { FC, useState } from 'react'
import { Checkbox } from 'antd'
import type { CheckboxChangeEvent } from 'antd/es/checkbox'
import useMyCourses from '@hooks/useMyCourses'
import useFormProcessor from '@hooks/useFormProcessor'
import useMe from '@hooks/useMe'
import ListPage from '@templates/ListPage'
import Onboarding from '@templates/Onboarding'
import OnboardingCodes from '@enums/OnboardingCodes'
import { FilterCheckboxWrapper } from '../styled'
import { ONBOARDING_STEPS, ONBOARDING_TITLE } from '../onboarding'
import InternalCourseFormModal from './InternalCourseFormModal'
import MyCourseItem from './MyCourseItem'
import useMyCoursesFilters from './useMyCoursesFilters'

const CoursesTab: FC = () => {
  const methods = useFormProcessor()
  const me = useMe()
  const isAdmin = me?.isAdmin || false
  const { isCompanyGroupCurator, isCompanyCurator, isFilialCurator } = me
  const canSeeOnboarding = isCompanyGroupCurator || isCompanyCurator || isFilialCurator

  const { data: coursesData, setFilters, ...rest } = useMyCourses()

  const filters = useMyCoursesFilters(methods, setFilters)
  const { items = [], length = 0 } = coursesData || {}

  const [showDeleted, setShowDeleted] = useState(false)

  const handleShowDeletedChange = (e: CheckboxChangeEvent) => {
    const checked = e.target.checked
    setShowDeleted(checked)
    setFilters((prev) => ({ ...prev, showDeleted: checked }))
  }

  return (
    <>
      {canSeeOnboarding && (
        <Onboarding
          firstStepTitle={ONBOARDING_TITLE}
          steps={ONBOARDING_STEPS}
          code={OnboardingCodes.my_courses_section}
        />
      )}
      <ListPage
        {...rest}
        setFilters={setFilters}
        methods={methods}
        ItemComponent={MyCourseItem}
        additionalPropsForItem={{ showDeleted }}
        filters={filters}
        filtersExtra={
          isAdmin ? (
            <FilterCheckboxWrapper>
              <Checkbox checked={showDeleted} onChange={handleShowDeletedChange}>
                Показать удалённые
              </Checkbox>
            </FilterCheckboxWrapper>
          ) : undefined
        }
        forceCollapsibleFilters
        list={items}
        length={length}
        titleTabs={[{ index: 0, title: 'Мои курсы', counter: length }]}
        selectedTab={0}
        withSearch
        searchPlaceholder="Поиск по названию курса"
        ModalContent={InternalCourseFormModal}
        addButtonTitle="Добавить"
        modalWithoutCloseOnOutsideClick
        resetOnboardingCodes={[
          OnboardingCodes.my_courses_section,
          OnboardingCodes.my_courses_create,
          OnboardingCodes.my_courses_open_card,
          OnboardingCodes.my_courses_final_test_create,
        ]}
      />
    </>
  )
}

export default CoursesTab
